// src/components/Services.jsx

import React from 'react';

const InclusionSummary = () => {
  return (
    <div>
    

      
   
<h2 className="text-4xl font-bold text-black">
  Inclusion<span className="text-[#680099] ml-2 font-bold">Summary</span>
</h2>


      {/* Container for the two boxes */}
      <div style={boxesContainerStyle}>
        {/* Left box */}
        <div style={leftBoxStyle}>
          <div style={boxHeadingStyle}>Revenue</div>
          <p style={boxContentStyle}> Commission On Bookings</p>
          <p style={leftboxContentStyle}> Forex Transaction Fees</p>
          <p style={leftboxContentStyle}> Future Subscription Model</p>
        </div>

        {/* middle box */}
        <div style={midBoxStyle}>
          <div style={boxHeadingStyle}>Description</div>
          <p style={boxContentStyle}> Revenue From Each Package Booked Via Exclusive DMC Partnerships For Competitive Pricing</p>
          <p style={boxContentStyle}> Revenue From Forex Transactions Post-FFMC License, Enhancing The One-Stop Solution.</p> 
          <p style={boxContentStyle}> Subscription Fees For Premium Platform Features (Expected Post Year 2)</p>
        </div>

        {/* Right box */}
        <div style={rightBoxStyle}>
          <div style={boxHeadingStyle}>Current / Projected Share</div>
          <p style={boxContentStyle}> 60 - 70% </p>
          <p style={rightboxContentStyle}> 15 - 25%</p>
          <p style={rightboxContentStyle}> 10 - 15%</p>
        </div>
      </div>

      
    </div>
  );
};

const boxesContainerStyle = {
  display: 'flex',  // Align items side by side
  gap: '20px',  // Space between the boxes
  marginTop: '19px',  // Optional: space between heading and boxes

};

const leftBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '20%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const midBoxStyle = {
  flex: 1,  // Takes up available space, but narrower due to specific width
  maxWidth: '60%',  // Adjust width to make it narrower
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
};

const rightBoxStyle = {
  flex: 1,  // Takes up available space
  backgroundColor: '#fbf4ff',  // Background color for the box
  borderRadius: '30px',
  padding: '0px',
  maxWidth: '20%',  // Adjust width to make it narrower

};

const boxHeadingStyle = {
  backgroundColor: '#321e5d',  // Background color for the heading
  color: 'white',
  padding: '10px',
  borderRadius: '30px 30px 0px 0px',   
  fontSize: '18px',
  fontWeight: 'bold',  
  textAlign: 'center',

  
};

const boxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px'
};


const leftboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '45px'
};

const rightboxContentStyle = {
  
  textAlign: 'center',
  marginTop: '20px',
  fontSize: '18px',
  marginTop: '45px'
};


export default InclusionSummary;
